import React from "react";
import footer from "../../../Assets/Styles/Footer.module.css";
import Newsletter from "./Newsletter";
import { Fragment } from "react";
import SubFooter from "./SubFooter";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Fragment>
      <footer className={footer.footer_container}>
        <div className="2xl:max-w-[1320px] max-xl:max-w-[1150px] mx-auto flex 2xl:flex-row flex-col 2xl:h-[480px] gap-20 ">
          <div className="2xl:w-[70%] flex max-md:gap-x-50 flex-col px-3 max-sm:px-10  max-md:px-0 max-md:flex-row justify-between py-20 ">
            <div className="max-md:w-[30%]">
              <h3 className="text-[#FFFFFF] text-2xl font-bold uppercase ">
                Contact Us
              </h3>
              <span className="w-[50px] h-[5px] bg-[#FF0000] block border-l-[10px] mt-2 border-[#fff]"></span>

              <div>
                <div className=" mt-10 max-md:mt-16 flex items-center gap-4 max-sm:gap-10">
                  <h6 className="bg-[#FF0000] flex justify-center items-center rounded-full w-[40px] h-[40px] py-[30px] px-[30px]  text-[#FFFF] text-center text-lg">
                    <i className="fa-solid fa-phone-volume"></i>
                  </h6>
                  <div className="flex flex-col ">
                    {" "}
                    <span className="text-[13px] leading-[19px] text-[#FFFFFF]">
                      Phone:
                    </span>
                    <span className="mt-[10px] text-[17px] text-[#FFFFFF] font-bold">
                      01540343775
                    </span>
                  </div>
                </div>
                <div className=" mt-8 flex items-center gap-5 max-sm:gap-10">
                  <h6 className="bg-[#FF0000] flex justify-center items-center rounded-full w-[40px] h-[40px] py-[30px] px-[30px]  text-[#FFFF] text-center text-lg">
                    <i className="fa-solid fa-envelope"></i>
                  </h6>
                  <div className="flex flex-col ">
                    {" "}
                    <span className="text-[13px] leading-[19px] text-[#FFFFFF]">
                      E-mail:
                    </span>
                    <span className="mt-[10px] text-[16px] text-[#FFFFFF] font-bold">
                      infoitghor24@gmail.com
                    </span>
                  </div>
                </div>
                <div className=" mt-8 flex items-center gap-5 max-sm:gap-10">
                  <h6 className="bg-[#FF0000] flex justify-center items-center rounded-full w-[40px] h-[40px] py-[30px] px-[30px]  text-[#FFFF] text-center text-lg">
                    <i className="fa-solid fa-location-dot"></i>
                  </h6>
                  <div className="flex flex-col ">
                    {" "}
                    <span className="text-[13px] leading-[19px] text-[#FFFFFF] font-semibold">
                      Polashpur D-Block #Road-03, Shonir Akhra, Dhaka,
                      Bangladesh,
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="max-md:w-[50%] mt-20 max-md:mt-0 ">
              <h3 className="text-[#FFFFFF] text-2xl font-bold uppercase ">
                Quick Links
              </h3>
              <span className="w-[50px] h-[5px] bg-[#FF0000] block border-l-[10px] mt-2 border-[#fff]"></span>
              <nav className="mt-[27px] flex-col max-md:flex-row flex gap-10">
                <div>
                  <ul>
                    <Link to="/">
                      <li className="text-[#FFFFFF] text-base mb-5  cursor-pointer">
                        {" "}
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        Home
                      </li>
                    </Link>
                    <Link to="/about">
                      <li className="text-[#FFFFFF] text-base mb-5  cursor-pointer">
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        About
                      </li>
                    </Link>
                    <Link to="/shop">
                      <li className="text-[#FFFFFF] text-base mb-5  cursor-pointer">
                        {" "}
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        Shop
                      </li>
                    </Link>
                    <Link to="/faqs">
                      <li className="text-[#FFFFFF] text-base mb-5  cursor-pointer">
                        {" "}
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        FAQ
                      </li>
                    </Link>
                  </ul>
                </div>
                <div>
                  <ul>
                    <Link to="/contact">
                      <li className="text-[#FFFFFF] text-base mb-5  cursor-pointer">
                        {" "}
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        Contact
                      </li>
                    </Link>
                    <Link to="/">
                      <li className="text-[#FFFFFF] text-base mb-5  cursor-pointer">
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        Customers
                      </li>
                    </Link>

                    <Link to="/blog">
                      <li className="text-[#FFFFFF] text-base mb-5 cursor-pointer">
                        {" "}
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        Blog Post
                      </li>
                    </Link>
                    <Link to="/contact">
                      <li className="text-[#FFFFFF] text-base mb-5 cursor-pointer">
                        {" "}
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        Support
                      </li>
                    </Link>
                  </ul>
                </div>
                <div>
                  <ul>
                    <Link to="/terms-and-condition">
                      <li className="text-[#FFFFFF] text-base mb-5 cursor-pointer">
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        Terms & Condition
                      </li>
                    </Link>
                    <Link to="/privacy-policy">
                      <li className="text-[#FFFFFF] text-base mb-5  cursor-pointer">
                        {" "}
                        <i className="fa-solid fa-caret-right mr-[13px] cursor-pointer"></i>{" "}
                        Privacy & policy
                      </li>
                    </Link>

                    <Link to="/blog">
                      <li className="text-[#FFFFFF] text-base mb-5 cursor-pointer ">
                        {" "}
                        <i className="fa-solid fa-caret-right mr-[13px]"></i>{" "}
                        Newsroom
                      </li>
                    </Link>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
          <Newsletter />
        </div>
      </footer>

      <SubFooter />
    </Fragment>
  );
};

export default Footer;
